import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { SharedFacade } from '@icc/configurator/shared';
import { IccFilling } from '@icc/window-door/types';
import { ActiveSash } from '@icc/window-door/types';
import { ConfigurationsService } from '@icc/configurator/shared';
import { WindowActiveConfiguration } from '@icc/window-door/types';
import { BehaviorSubject } from 'rxjs';
import { PanelOptionsFacade } from './panel-options.facade';

@Component({
    selector: 'icc-deco-panel-options-page',
    templateUrl: './deco-panel-options-page.component.html',
    styleUrls: ['./deco-panel-options-page.component.scss'],
    standalone: false
})
export class DecoPanelOptionsPageComponent extends PageComponent implements OnInit {
    public title = _('DOOR|Opcje panelu ozdobnego');
    public options = [];

    public panelGlazingBox: ReturnType<
        PanelOptionsFacade['panelGlazingBox']
    > = this.panelOptionsFacade.panelGlazingBox(
        this.configurationsService.conf.Current,
        this.pageData.selGlazing
    );
    public selectedPanelGlazing: ActiveSash['panelGlazing'] = {};
    public panelType: ActiveSash['panelType'] = 'Inset';
    public selectedFilling: ActiveSash['glazing'] = {};
    public selectedPanelTrim: ActiveSash['panelTrim'] = {};
    public selectedInnerPanelTrim: ActiveSash['innerPanelTrim'] = {};

    constructor(
        private sharedFacade: SharedFacade,
        private panelOptionsFacade: PanelOptionsFacade,
        private configurationsService: ConfigurationsService<'door'>,
        @Inject(ICC_PAGE_DATA)
        public pageData: {
            fillings: IccFilling[];
            fillingsCategories: any[];
            modalData: any;
            selGlazing: ActiveSash['panelGlazing'];
            panelType: ActiveSash['panelType'];
            filling: ActiveSash['glazing'];
            filteredFillings: IccFilling[];
            panelTrims: IccFilling[];
            innerPanelTrims: IccFilling[];
            panelTrim: ActiveSash['panelTrim'];
            innerPanelTrim: ActiveSash['innerPanelTrim'];
            openFillingModal: (
                panelGlazings: IccFilling[],
                selectedFilling: Partial<IccFilling>,
                conf: WindowActiveConfiguration
            ) => PromiseLike<any>;
            changePanelTrim: (
                face: "outside" | "inside"
            ) => PromiseLike<any>;
            options$: BehaviorSubject<{
                selGlazing: ActiveSash['panelGlazing'];
                panelType: ActiveSash['panelType'];
                filling: ActiveSash['glazing'];
                panelTrim: ActiveSash['panelTrim'];
                innerPanelTrim: ActiveSash['innerPanelTrim'];
            }>;
        }
    ) {
        super();
        this.selectedPanelGlazing = this.pageData.selGlazing;
        this.selectedPanelTrim = this.pageData.panelTrim;
        this.selectedInnerPanelTrim = this.pageData.innerPanelTrim;
        console.log('pageData', this.pageData, this.selectedPanelTrim);
        this.panelType = this.pageData.panelType;
        this.pageData.options$.subscribe(data => {
            this.selectedPanelGlazing = data.selGlazing;
            this.panelType = data.panelType;
            this.selectedFilling = data.filling;
            this.panelGlazingBox = this.panelOptionsFacade.panelGlazingBox(
                this.configurationsService.conf.Current,
                data.selGlazing
            );
            this.selectedPanelTrim = data.panelTrim;
            this.selectedInnerPanelTrim = data.innerPanelTrim;
        });
    }

    ngOnInit() {}

    isPanelGlazingSelectionDisabled() {
        return !this.pageData.fillings.some(filling => Number(filling.id) !== Number(this.selectedPanelGlazing?.id));
    }

    isPanelTrimSelectionDisabled(side: 'outside' | 'inside') {
        const trims = side === 'outside' ? this.pageData.panelTrims : this.pageData.innerPanelTrims;
        const selected = side === 'outside' ? this.selectedPanelTrim : this.selectedInnerPanelTrim;
        return !trims.some(trim => Number(trim.id) !== Number(selected?.id));
    }

    changePanelGlazing() {
        this.pageData
            .openFillingModal(
                this.pageData.fillings,
                this.pageData.selGlazing,
                this.configurationsService.conf.Current
            )
            .then(result => {
                if (result) {
                    this.pageData.options$.next({
                        selGlazing: result.glazing,
                        panelType: this.panelType,
                        filling: this.selectedFilling,
                        panelTrim: this.selectedPanelTrim,
                        innerPanelTrim: this.selectedInnerPanelTrim,
                    });
                }
            });
    }

    changePanelTrim(side: 'outside' | 'inside') {
        this.pageData
            .changePanelTrim(side)
            .then(result => {
                if (result) {
                    this.pageData.options$.next({
                        selGlazing: this.selectedPanelGlazing,
                        panelType: this.panelType,
                        filling: this.selectedFilling,
                        panelTrim: result.trim,
                        innerPanelTrim: result.innerTrim,
                    });
                }
            });
    }

    setPanelType(panelType: ActiveSash['panelType'], filling: IccFilling) {
        this.panelType = panelType;
        this.selectedFilling = filling;
    }

    save() {
        this.sharedFacade.closePage({
            selGlazing: this.selectedPanelGlazing,
            panelType: this.panelType,
            filling: this.selectedFilling,
        });
    }
}
